import React from "react";
import ContentWrapper from "src/components/layouts/content-wrapper";
import Datatable from "./datatable";

const UsersTab = () => {
  return (
    <ContentWrapper>
      <Datatable />
    </ContentWrapper>
  );
};

export default UsersTab;
